// extracted by mini-css-extract-plugin
export default {"container":"terms&policy_container__rr+sh","containermain":"terms&policy_containermain__xaP7l"};